import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#141610]">
    <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 grid gap-10 md:grid-cols-3">
      <div>
        <img src="/logo.png" alt="Infinite Siding LLC" className="h-14 w-auto logo-on-dark" data-testid="footer-logo" />
        <p className="mt-5 text-white/50 text-sm leading-relaxed max-w-xs">
          Siding installation done right — for homes and commercial buildings across the tri-state area.
        </p>
      </div>
      <div className="text-sm space-y-3 text-white/70">
        <p className="font-display text-xl text-white tracking-wide mb-4">CONTACT</p>
        <p className="flex items-center gap-3"><Phone size={15} className="text-primary" aria-hidden="true" /><a href="tel:+12033075222" data-testid="footer-phone" className="hover:text-primary transition-colors duration-300">(203) 307-5222</a></p>
        <p className="flex items-center gap-3"><Mail size={15} className="text-primary" aria-hidden="true" /><a href="mailto:yali@infinitesiding.com" data-testid="footer-email" className="hover:text-primary transition-colors duration-300">yali@infinitesiding.com</a></p>
        <p className="flex items-center gap-3"><Clock size={15} className="text-primary" aria-hidden="true" />Mon – Sat · 7:00 AM – 8:00 PM</p>
      </div>
      <div className="text-sm space-y-3 text-white/70">
        <p className="font-display text-xl text-white tracking-wide mb-4">SERVICE AREAS</p>
        <p className="flex items-center gap-3"><MapPin size={15} className="text-primary" aria-hidden="true" />New York · Connecticut · Massachusetts</p>
        <p className="text-white/40">Licensed &amp; insured contractor.</p>
        <div className="flex gap-6 pt-2 text-xs uppercase tracking-widest">
          <Link to="/residential" data-testid="footer-residential-link" className="hover:text-primary transition-colors duration-300">Residential</Link>
          <Link to="/commercial" data-testid="footer-commercial-link" className="hover:text-primary transition-colors duration-300">Commercial</Link>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 text-center text-xs text-white/30 tracking-wide">
      © {new Date().getFullYear()} Infinite Siding LLC. All rights reserved.
    </div>
  </footer>
);
